import { Statistic, Row, Col, Card } from "antd";
import { useEffect, useState } from "react";
import CountUp from "react-countup";
import { callFetchDashboard } from "../../../config/api";

const AdminDashboard = () => {
  const [dataDashboard, setDataDashboard] = useState({
    countPost: 0,
    countUser: 0,
  });
  useEffect(() => {
    const initDashboard = async () => {
      const res = await callFetchDashboard();
      if (res && res.data) {
        setDataDashboard(res.data.data);
      }
    };
    initDashboard();
  }, []);
  const formatter = (value: any) => <CountUp end={value} separator="," />;
  return (
    <Row gutter={[40, 40]}>
      <Col span={10}>
        <Card title="" bordered={false}>
          <Statistic
            title="Tổng Users"
            value={dataDashboard.countUser}
            formatter={formatter}
          />
        </Card>
      </Col>
      <Col span={10}>
        <Card title="" bordered={false}>
          <Statistic
            title="Tổng Posts"
            value={dataDashboard.countPost}
            formatter={formatter}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default AdminDashboard;
